module.exports = __webpack_public_path__ + "static/media/read_content_aloud_telugu.1d7d9ebb.mp3";